/** @file A bone transform channel's absolute value at a frame, as animation.setKey takes it (ends held). */
import type { Doc, Id } from '@pose2d/format/types';
import { buildCurveTrack } from '../curves/buildCurveTrack';
import { curveSegment } from '../curves/curveSegment';
import type { TRANSFORM_CHANNELS } from './transformChannels.data';

/** One of the seven keyable transform channels. */
export type TransformChannel = (typeof TRANSFORM_CHANNELS)[number]['channel'];

/**
 * Absolute value at `frame` by core's sampling rule (held before the first and after the last key), the compiler's
 * curve code and core's evalCurve — read through the curve editor's display track (W3-43), so the Inspector and the
 * graph show the same number; the setup value when the channel has no key.
 */
export function channelValueAt(doc: Doc, animation: Id, bone: Id, channel: TransformChannel, frame: number): number {
  const track = buildCurveTrack(doc, { animation, channel, target: bone });
  return track === null ? (doc.bones[bone]?.setup[channel] ?? 0) : curveSegment.frameValue(track, frame);
}
